import {
  SEND_RESET_TOKEN,
  SEND_RESET_PIN,
  CHECK_USER_LOGIN
} from "../gql/AuthQueries";

import debounce from "lodash/debounce";

import {
  required,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";

export default {
  name: "forgot_password",

  data() {
    return {
      login: "",
      sentSuccess: false,
      submitLoading: false,
      checkLogin: {},
      skipCheckLoginQuery: true,
      isRealLogin: true
    };
  },

  validations() {
    let params = {
      login: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(256)
      }
    };

    if (this.isLoginEmail) {
      params.login = {
        required,
        email,
        minLength: minLength(5),
        maxLength: maxLength(256)
      };
    }

    return params;
  },

  apollo: {
    checkLogin: {
      query: CHECK_USER_LOGIN,
      variables() {
        return {
          login: this.login
        };
      },

      skip() {
        return this.skipCheckLoginQuery;
      },

      result({
        data: {
          checkLogin: { isExist }
        }
      }) {
        this.skipCheckLoginQuery = true;
        this.isRealLogin = isExist;
      }
    }
  },

  computed: {
    isLoginEmail() {
      return this.login.indexOf("@") > -1;
    }
  },

  methods: {
    handleCheckLogin: debounce(function() {
      this.skipCheckLoginQuery = false;
    }, 300),

    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitLoading = true;

        if (this.isLoginEmail) {
          this.resetByEmail();
        } else {
          this.resetByPhone();
        }
      }
    },

    resetByEmail() {
      this.$apollo
        .mutate({
          mutation: SEND_RESET_TOKEN,
          variables: {
            email: this.login
          }
        })
        .then(({ data: { sendResetToken: { status } } }) => {
          this.$toasted.success("A message should arrive within minutes!");

          this.sentSuccess = true;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    resetByPhone() {
      // localStorage.setItem("signupPhone", this.login);

      // this.$router.push({
      //   name: "confirmation_phone",
      //   params: { resetPassword: true }
      // });

      this.$apollo
        .mutate({
          mutation: SEND_RESET_PIN,
          variables: {
            phone: this.login
          }
        })
        .then(({ data: { sendResetPin: { status } } }) => {
          this.$toasted.success("We have sent you a message!");

          localStorage.setItem("signupPhone", this.login);

          this.$router.push({
            name: "reset_password_confirmation"
          });
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  },

  components: {}
};
